import { SplitContext } from 'containers/SplitContext'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import DeliveryOrderDetails from '../DeliveryOrders/Details'
import ListPage from './ListPage'

class DeliveryOrdersPickingRouter extends Component {
  render() {
    const { router } = this.props
    const details = { ...this.props, url: '/operations' }
    if (router.match.params.id) {
      return <DeliveryOrderDetails {...details} />
    }
    return <ListPage {...details} className="ops" />
  }
}

export default withRouter(({ match, ...props }) => {
  const splitConfig = React.useContext(SplitContext)

  return (
    <DeliveryOrdersPickingRouter
      router={{ match }}
      {...props}
      splits={splitConfig?.splits}
    />
  )
})

export { ListPage }
